import React, {useEffect, useState} from 'react';
import Accordian from '../../../utils/accordion';
import Link from 'next/link';

const SeminarPage = (props) => {

    const seminar_data = props?.seminarData?.length ? props?.seminarData[0] : null;
    // console.log("seminar_data",seminar_data);
    useEffect(() => {

        const script = document.createElement('script');
        script.setAttribute(
          "src",
          "https://fs23.formsite.com/include/form/embedManager.js?1079421939"
        );
        script.addEventListener('load', () => {
            EmbedManager.embed({
                key: "https://fs23.formsite.com/res/showFormEmbed?EParam=m_OmK8apOTD5ovQ3l4B2tWrgI846v8s2FzpUCZwnDno&1079421939",
                width: "100%",
                mobileResponsive: true
            });
        });
        document.getElementById('embed-seminar').appendChild(script);

    }, []);

    let image_content = seminar_data?.course_available?.content_image.map((innerItem, index) => (
        <>
            <div className="" dangerouslySetInnerHTML={{__html: innerItem?.outer_content ?? ''}}></div>
            <div className="books-container">
                <div className="text-area">
                    <div className="" dangerouslySetInnerHTML={{__html: innerItem?.inner_content ?? ''}}></div>
                </div>
                <div className="img-area">
                    <span>
                        {innerItem?.image?.url &&
                        <img src={`${process.env.CMS_API_ORIGIN}${innerItem?.image?.url}`}></img>
                        }
                    </span>
                </div>
            </div>
        </>
    ));


    let seminarData = [];
    seminarData = seminar_data?.seminar_accordion?.map((key, index) => {
        return {
            heading: key.heading,
            content: key.content,
            open: false
        };
    });
    const [seminar, setSeminar] = useState(seminarData);

    let enrollment_detail = seminar_data?.course_registration?.enrollment_detail?.map((key, index) => (
        <tr>
            <td>{key?.session_detail ?? null}</td>
            <td>{key?.per_person_detail ?? null}</td>
        </tr>
    ));
    return (
        <div className='bayan-seminar'>
            <div className='seminar-container'>
                <span className="fullwide">
                    <Link href='/degree-programs' as='degree-programs'>
                        <a className="backbtn">Back</a>
                    </Link>
                </span>
                <div className="top-container">

                    <div className="left-section">
                        <div className='seminar-headings'>
                            <div dangerouslySetInnerHTML={{__html: seminar_data?.seminar_header?.seminar_headings?.heading ?? ''}} />
                        </div>
                        <div dangerouslySetInnerHTML={{__html: seminar_data?.seminar_header?.seminar_content?.heading ?? ''}} />
                        <div dangerouslySetInnerHTML={{__html: seminar_data?.seminar_header?.seminar_content?.description ?? ''}} />
                    </div>
                    {/* <div className="right-section">
                        <span>
                            <img alt="jihad brown" src={`${process.env.IMAGES_BASE_URL}/static-content/jihadbrown.png.webp`}/>
                        </span>
                    </div> */}
                </div>
                <div dangerouslySetInnerHTML={{__html: seminar_data?.spring_term?.heading ?? ''}}/>
                <div dangerouslySetInnerHTML={{__html: seminar_data?.spring_term?.content ?? ''}}/>
                <div dangerouslySetInnerHTML={{ __html: seminar_data?.course_available?.heading??''}}/>
                {image_content ?? ''}
                <div dangerouslySetInnerHTML={{__html: seminar_data?.course_registration?.heading ?? ''}}/>
                <div dangerouslySetInnerHTML={{__html: seminar_data?.course_registration?.description_b ?? ''}}/>
                <div className='seminar-table'>
                    <table>
                        <tr>
                            <th>{seminar_data?.course_registration?.enrollment_title?.session_title ?? 'Semester'}</th>
                            <th>{seminar_data?.course_registration?.enrollment_title?.per_person_title ?? 'Per Person'}</th>
                        </tr>
                        {enrollment_detail ?? ''}
                    </table>
                    <div dangerouslySetInnerHTML={{__html: seminar_data?.course_registration?.description_a ?? ''}}/>
                    <div id='embed-seminar'>
                        <a name="form1079421939" id="formAnchor1079421939"/>
                    </div>
                    <div className='seminar-accordians'>
                        <Accordian accordions={seminar} setAccordions={setSeminar}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SeminarPage;
